
































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { DefaultInvoicesFilters } from "@/data/filters/invoice";
import { DefaultInvoicesSorters } from "@/data/sorters/invoices";
import { IClient } from "@/models/clients";
import { IContract, IContractProduct } from "@/models/contracts";
import { IInvoice } from "@/models/invoices";
import { ISorter, IFilter } from "@/models/tables";

import Context from "@/mixins/context";
import InvoicesProvider from "@/components/app/global/invoices/invoicesProvider.vue";

@Component({
  components: {
    InvoicesProvider,
    "invoices-table-view": () =>
      import("@/components/app/global/invoices/invoicesTableView.vue")
  }
})
export default class InvoicesListing extends Mixins(Context) {
  $refs!: {
    invoicesProvider: InvoicesProvider;
  };
  // Props
  @Prop({ default: /** Invoices provider 1 */ `IP1` })
  public id!: string;

  @Prop({ default: undefined })
  public dataScope!: string;

  @Prop({ default: null })
  public clientId!: IClient["id"];

  @Prop({ default: null })
  public contractId!: IContract["id"];

  @Prop({ default: undefined })
  public productId!: IContractProduct["id"];

  @Prop({ default: true })
  public autofocus!: boolean;

  @Prop({ default: false })
  public isSelectable!: boolean;

  @Prop({ default: () => [] })
  public selectedIds!: IInvoice["id"][];

  @Prop({ default: () => DefaultInvoicesFilters })
  public availableFilters!: (vm: InvoicesListing) => IFilter[];

  @Prop({ default: () => DefaultInvoicesSorters })
  public availableSorters!: (vm: InvoicesListing) => ISorter[];

  @Prop({ default: () => () => ({}) })
  public manualFilters!: (
    vm?: InvoicesListing
  ) => Record<string, string | number | boolean>;

  @Prop({ default: false })
  public isSelectedLinked!: boolean;

  public invoicesFilters: IFilter[] = [];
  public invoicesSorters: ISorter[] = [];

  public created() {
    this.invoicesFilters = this.availableFilters(this);
    this.invoicesSorters = this.availableSorters(this);
  }

  public reloadData() {
    this.$refs?.invoicesProvider?.reloadData();
  }

  /** Important: Note that manualFilters is passed as a function, thus we must
   * compute the value before passing to the invoicesProvider */

  public get manualFiltersComputed() {
    return this.manualFilters();
  }
}
